export const dramas = [
  {
    id: 'silent-marriage',
    title: '沉默的婚姻',
    enTitle: 'The Silent Marriage',
    year: 2025,
    rating: 8.9,
    region: '韩国',
    genres: ['婚姻情感', '家庭伦理'],
    tags: ['中产危机', '情感疏离', '现实题材'],
    director: '朴正勋',
    cast: [
      { name: '金惠秀', role: '饰 徐真雅' },
      { name: '李成宰', role: '饰 姜道允' },
      { name: '韩昭熙', role: '饰 徐幼珍' },
    ],
    status: '更新至第14集',
    episodes: 16,
    updatedAt: '2025-10-08',
    summary: '一对看似圆满的中产夫妻，在日复一日的沉默里逐渐走散，直到一封匿名信揭开十五年前的秘密。',
    synopsis:
      '结婚十二年的徐真雅与姜道允，是旁人眼中最标准的中产家庭样本：体面的工作、懂事的孩子、干净的公寓。可晚饭后的客厅里只剩下电视的声音。当真雅在旧书里翻出一封没有署名的信，一段被刻意遗忘的往事重新浮出水面。她开始重新审视这段婚姻里所有被无声省略的瞬间——是妥协，还是早已放弃。剧集以细腻克制的镜头，讲述一段关于孤独、理解与重新选择的故事。',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20Korean%20drama%20poster%20of%20a%20thoughtful%20middle%20aged%20woman%20standing%20by%20a%20rain%20streaked%20window%20in%20a%20dim%20apartment%2C%20cold%20navy%20blue%20tones%20with%20a%20single%20warm%20amber%20lamp%2C%20quiet%20emotional%20tension%2C%20minimal%20elegant%20background%2C%20editorial%20film%20photography%2C%20refined%20high%20detail&width=600&height=840&seq=kd-silent-marriage-poster&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20still%20of%20a%20dim%20modern%20apartment%20living%20room%20at%20night%2C%20a%20woman%20silhouette%20by%20a%20large%20rainy%20window%2C%20deep%20navy%20blue%20tones%20with%20a%20single%20warm%20amber%20lamp%2C%20moody%20quiet%20atmosphere%2C%20minimal%20elegant%20composition%2C%20editorial%20film%20photography%2C%20high%20detail&width=1600&height=900&seq=kd-silent-marriage-bd&orientation=landscape',
    views: 1284000,
    hot: true,
    featured: true,
  },
  {
    id: 'borrowed-time',
    title: '借来的时光',
    enTitle: 'Borrowed Time',
    year: 2025,
    rating: 9.1,
    region: '韩国',
    genres: ['亲情成长', '家庭伦理'],
    tags: ['亲情', '告别', '治愈'],
    director: '郑允雅',
    cast: [
      { name: '薛景求', role: '饰 吴泰九' },
      { name: '金泰璃', role: '饰 吴夏恩' },
      { name: '刘在明', role: '饰 朴医生' },
    ],
    status: '全16集',
    episodes: 16,
    updatedAt: '2025-09-30',
    summary: '得知父亲只剩半年时间后，疏远多年的女儿回到老宅，用一台旧相机重新记录被错过的每一天。',
    synopsis:
      '在外漂泊多年的摄影师吴夏恩，因为父亲的一纸诊断书回到海边老宅。父亲吴泰九是个不擅表达的木匠，父女之间横亘着母亲离世后十几年的沉默。夏恩决定用相机记录下父亲余下的时光，却在每一次按下快门的间隙，重新认识了这个沉默的男人。剧集以温暖而克制的方式探讨告别与和解，让人明白所谓借来的时光，其实一直就在手边。',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20Korean%20drama%20poster%20of%20a%20young%20man%20holding%20an%20old%20wristwatch%20in%20soft%20golden%20light%2C%20muted%20navy%20background%20with%20amber%20highlights%2C%20nostalgic%20melancholy%20mood%2C%20minimal%20elegant%20composition%2C%20editorial%20film%20photography%2C%20refined%20high%20detail&width=600&height=840&seq=kd-borrowed-time-poster&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20still%20of%20an%20old%20seaside%20wooden%20house%20at%20golden%20hour%2C%20warm%20amber%20sunlight%20through%20dusty%20windows%2C%20deep%20navy%20sea%20in%20the%20distance%2C%20nostalgic%20gentle%20mood%2C%20minimal%20elegant%20composition%2C%20editorial%20film%20photography%2C%20high%20detail&width=1600&height=900&seq=kd-borrowed-time-bd&orientation=landscape',
    views: 1426000,
    hot: true,
    featured: true,
  },
  {
    id: 'glass-heart',
    title: '玻璃心',
    enTitle: 'Glass Heart',
    year: 2025,
    rating: 8.6,
    region: '韩国',
    genres: ['女性题材', '婚姻情感'],
    tags: ['心理', '自我救赎', '都市'],
    director: '闵秀珍',
    cast: [
      { name: '申敏儿', role: '饰 车瑞妍' },
      { name: '柳演锡', role: '饰 韩志勋' },
      { name: '金智英', role: '饰 车母' },
    ],
    status: '更新至第12集',
    episodes: 16,
    updatedAt: '2025-10-05',
    summary: '一位表面完美的心理咨询师，在帮助他人修复关系的同时，却无法面对自己支离破碎的婚姻。',
    synopsis:
      '车瑞妍是首尔小有名气的心理咨询师，她用温柔且专业的方式治愈过无数濒临破裂的关系，自己的婚姻却早已千疮百孔。当丈夫韩志勋提出分居，她精心维护的完美外壳第一次出现裂缝。剧集以女性视角切入，冷静地拆解成年人关于自尊、依赖与重新出发的课题，告诉观众脆弱从来不是失败的证明。',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20Korean%20drama%20poster%20of%20a%20delicate%20woman%20in%20a%20pale%20dress%20seen%20through%20frosted%20glass%2C%20cool%20navy%20tones%20with%20warm%20amber%20glow%2C%20fragile%20emotional%20atmosphere%2C%20minimal%20elegant%20background%2C%20editorial%20film%20photography%2C%20high%20detail&width=600&height=840&seq=kd-glass-heart-poster&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20still%20of%20a%20minimal%20modern%20counseling%20room%2C%20soft%20frosted%20glass%20partitions%2C%20cool%20navy%20tones%20with%20warm%20amber%20afternoon%20light%2C%20quiet%20contemplative%20mood%2C%20elegant%20composition%2C%20editorial%20film%20photography%2C%20high%20detail&width=1600&height=900&seq=kd-glass-heart-bd&orientation=landscape',
    views: 986000,
    hot: true,
    featured: true,
  },
  {
    id: 'the-other-mother',
    title: '另一个母亲',
    enTitle: 'The Other Mother',
    year: 2024,
    rating: 8.7,
    region: '韩国',
    genres: ['家庭伦理', '亲情成长'],
    tags: ['养育', '身份', '催泪'],
    director: '崔东勋',
    cast: [
      { name: '罗美兰', role: '饰 全美淑' },
      { name: '金高银', role: '饰 韩诗雅' },
      { name: '朴海日', role: '饰 郑成宇' },
    ],
    status: '全20集',
    episodes: 20,
    updatedAt: '2025-08-18',
    summary: '一场车祸后，一个孩子被迫在两个母亲之间做出选择，血缘与养育的重量被摆在阳光之下。',
    synopsis:
      '经营小饭馆的全美淑抚养诗雅长大，直到亲子鉴定结果揭开，诗雅并非她的亲生女儿。另一边，出身优渥的郑成宇夫妇才是诗雅血缘上的父母。两个阶层、两种爱，围绕一个问题展开：究竟什么才算母亲。剧集没有简单评判对错，而是让每个人在挣扎中暴露自己的软肋，最终指向一个关于爱的朴素答案。',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20Korean%20drama%20poster%20of%20two%20women%20standing%20apart%20in%20a%20quiet%20hallway%2C%20cool%20navy%20shadows%20and%20warm%20amber%20window%20light%2C%20unspoken%20rivalry%2C%20minimal%20elegant%20background%2C%20editorial%20film%20photography%2C%20refined%20high%20detail&width=600&height=840&seq=kd-other-mother-poster&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20still%20of%20a%20warm%20small%20family%20restaurant%20interior%20at%20dusk%2C%20amber%20lamp%20light%20with%20cool%20navy%20shadows%2C%20humble%20cozy%20atmosphere%2C%20minimal%20elegant%20composition%2C%20editorial%20film%20photography%2C%20high%20detail&width=1600&height=900&seq=kd-other-mother-bd&orientation=landscape',
    views: 1120000,
    hot: true,
    featured: true,
  },
  {
    id: 'weight-of-home',
    title: '家的重量',
    enTitle: 'The Weight of Home',
    year: 2024,
    rating: 8.4,
    region: '韩国',
    genres: ['家庭伦理', '亲情成长'],
    tags: ['代际', '养老', '现实'],
    director: '朴正勋',
    cast: [
      { name: '成东日', role: '饰 高万石' },
      { name: '廉晶雅', role: '饰 高恩熙' },
      { name: '崔宇植', role: '饰 高俊昊' },
    ],
    status: '全16集',
    episodes: 16,
    updatedAt: '2025-07-22',
    summary: '老宅面临拆迁，三个早已离家的子女被迫重聚，为一张房产证撕开多年未愈的伤口。',
    synopsis:
      '高万石独自守着城郊的老宅，直到拆迁通知贴上门。三个子女从不同的城市赶回，围绕房产的分割争执不休。看似关于利益的争吵背后，是每个人对父母偏心、对童年缺失的旧账。剧集用一顿顿家常饭串起整个故事，让观众在两代人的对话里，看见自己家里的影子。',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20Korean%20drama%20poster%20of%20an%20elderly%20father%20and%20grown%20daughter%20facing%20each%20other%20across%20a%20wooden%20dining%20table%2C%20muted%20navy%20and%20amber%20color%20grade%2C%20warm%20soft%20light%20from%20above%2C%20quiet%20family%20tension%2C%20minimal%20background%2C%20editorial%20film%20photography%2C%20high%20detail&width=600&height=840&seq=kd-weight-of-home-poster&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20still%20of%20an%20old%20suburban%20Korean%20house%20at%20twilight%2C%20warm%20amber%20windows%20against%20deep%20navy%20blue%20sky%2C%20gentle%20nostalgic%20mood%2C%20minimal%20elegant%20composition%2C%20editorial%20film%20photography%2C%20high%20detail&width=1600&height=900&seq=kd-weight-of-home-bd&orientation=landscape',
    views: 876000,
    hot: false,
    featured: false,
  },
  {
    id: 'secrets-in-autumn',
    title: '秋日秘密',
    enTitle: 'Secrets in Autumn',
    year: 2025,
    rating: 8.8,
    region: '韩国',
    genres: ['悬疑伦理', '婚姻情感'],
    tags: ['悬疑', '秘密', '反转'],
    director: '郑允雅',
    cast: [
      { name: '金喜爱', role: '饰 尹珠兰' },
      { name: '李到晛', role: '饰 尹书俊' },
      { name: '文素利', role: '饰 姜律师' },
    ],
    status: '更新至第10集',
    episodes: 14,
    updatedAt: '2025-10-10',
    summary: '一位母亲在整理亡夫遗物时发现一部陌生手机，随着秋叶落尽，一个被掩埋的秘密家庭浮出水面。',
    synopsis:
      '丈夫意外离世后，尹珠兰在整理书房时发现一部从没见过的旧手机。屏幕亮起的那一刻，一个她从未听说过的名字反复出现。她循着线索走进另一个女人的生活，也逐渐走近丈夫不为人知的另一面。剧集节奏沉稳，把悬疑与情感揉进秋日的冷色调里，追问亲密关系中究竟藏着多少未曾言说的角落。',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20Korean%20drama%20poster%20of%20a%20woman%20walking%20alone%20down%20an%20autumn%20path%20with%20falling%20leaves%2C%20muted%20navy%20sky%20and%20amber%20foliage%2C%20secretive%20melancholy%20mood%2C%20minimal%20composition%2C%20editorial%20film%20photography%2C%20high%20detail&width=600&height=840&seq=kd-secrets-autumn-poster&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20still%20of%20a%20quiet%20autumn%20park%20avenue%20with%20falling%20golden%20leaves%2C%20cool%20navy%20overcast%20light%20with%20warm%20amber%20accents%2C%20mysterious%20contemplative%20mood%2C%20elegant%20composition%2C%20editorial%20film%20photography%2C%20high%20detail&width=1600&height=900&seq=kd-secrets-autumn-bd&orientation=landscape',
    views: 1035000,
    hot: true,
    featured: false,
  },
  {
    id: 'her-second-spring',
    title: '她的第二个春天',
    enTitle: 'Her Second Spring',
    year: 2025,
    rating: 8.5,
    region: '韩国',
    genres: ['女性题材', '亲情成长'],
    tags: ['中年女性', '重启人生', '治愈'],
    director: '闵秀珍',
    cast: [
      { name: '金喜善', role: '饰 吴晶恩' },
      { name: '郑敬淏', role: '饰 李在民' },
      { name: '朴宝英', role: '饰 吴小恩' },
    ],
    status: '全12集',
    episodes: 12,
    updatedAt: '2025-09-12',
    summary: '离婚后的四十岁女人重新走进职场，从一间快要倒闭的书店开始，找回被生活磨掉的自己。',
    synopsis:
      '吴晶恩在四十二岁这年结束了一场长达十八年的婚姻。没有房产、没有存款，只剩下一间母亲留下的旧书店和女儿的学费要付。她笨拙地学着使用外卖软件、学着谈合作、学着在被拒绝之后第二天照常开门。剧集温柔而坚定，讲述一个普通女人如何在废墟上重新开花，也关于所有"来不及"的人。',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20Korean%20drama%20poster%20of%20a%20smiling%20woman%20in%20her%20forties%20opening%20a%20curtain%20to%20morning%20light%2C%20soft%20navy%20blue%20interior%20with%20warm%20amber%20sunlight%2C%20hopeful%20mood%2C%20minimal%20elegant%20background%2C%20editorial%20film%20photography%2C%20high%20detail&width=600&height=840&seq=kd-second-spring-poster&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20still%20of%20a%20cozy%20old%20bookstore%20interior%20in%20warm%20morning%20light%2C%20muted%20navy%20shelves%20with%20amber%20sunbeams%2C%20hopeful%20gentle%20atmosphere%2C%20minimal%20elegant%20composition%2C%20editorial%20film%20photography%2C%20high%20detail&width=1600&height=900&seq=kd-second-spring-bd&orientation=landscape',
    views: 764000,
    hot: false,
    featured: false,
  },
  {
    id: 'promise-by-the-sea',
    title: '海边的约定',
    enTitle: 'Promise by the Sea',
    year: 2024,
    rating: 8.3,
    region: '韩国',
    genres: ['婚姻情感', '亲情成长'],
    tags: ['初恋', '重逢', '治愈'],
    director: '崔东勋',
    cast: [
      { name: '孙艺珍', role: '饰 韩瑞真' },
      { name: '苏志燮', role: '饰 姜泰河' },
      { name: '金赛纶', role: '饰 小海' },
    ],
    status: '全16集',
    episodes: 16,
    updatedAt: '2025-06-28',
    summary: '二十年前分手的一对恋人，因为一座即将拆除的海边灯塔再次相遇，旧约重提。',
    synopsis:
      '韩瑞真成了小渔村的民宿老板，姜泰河则是被派来评估灯塔拆除方案的建筑师。二十年前他们在这座灯塔下约定等彼此三年，最终谁都没有回来。如今重逢，两人都已带着各自的人生与伤痕。剧集用海风、黄昏和一次次沉默的并肩，讲述关于时间能不能磨平遗憾这件事。',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20Korean%20drama%20poster%20of%20a%20couple%20standing%20on%20a%20windy%20seaside%20pier%20at%20dusk%2C%20deep%20navy%20sea%20and%20warm%20amber%20sunset%20glow%2C%20romantic%20and%20bittersweet%2C%20minimal%20elegant%20composition%2C%20editorial%20film%20photography%2C%20high%20detail&width=600&height=840&seq=kd-promise-sea-poster&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20still%20of%20an%20old%20stone%20lighthouse%20on%20a%20rocky%20shore%20at%20sunset%2C%20deep%20navy%20ocean%20with%20warm%20amber%20sky%2C%20nostalgic%20bittersweet%20mood%2C%20minimal%20elegant%20composition%2C%20editorial%20film%20photography%2C%20high%20detail&width=1600&height=900&seq=kd-promise-sea-bd&orientation=landscape',
    views: 812000,
    hot: false,
    featured: false,
  },
  {
    id: 'mothers-choice',
    title: '母亲的选择',
    enTitle: "A Mother's Choice",
    year: 2024,
    rating: 8.6,
    region: '韩国',
    genres: ['家庭伦理', '女性题材'],
    tags: ['母爱', '两难', '催泪'],
    director: '朴正勋',
    cast: [
      { name: '金惠子', role: '饰 李金顺' },
      { name: '全度妍', role: '饰 李恩珠' },
      { name: '李政宰', role: '饰 崔民秀' },
    ],
    status: '全18集',
    episodes: 18,
    updatedAt: '2025-05-16',
    summary: '当两个孩子的未来只能保全一个，一位母亲被迫做出她此生最残忍的决定。',
    synopsis:
      '李金顺是个普通到不能再普通的母亲，靠着一个小摊养活两个孩子。一场变故让家庭陷入绝境，她不得不在两个孩子的前途之间做出取舍。剧集没有给出轻松的道德答案，而是把镜头对准抉择之后漫长的日常：愧疚、沉默、以及孩子们迟来的理解。这是一部让观众重新理解"母亲"两个字的作品。',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20Korean%20drama%20poster%20of%20a%20mother%20holding%20a%20small%20child%20shoe%20in%20dim%20light%2C%20muted%20navy%20shadows%20and%20warm%20amber%20highlights%2C%20tender%20painful%20conflict%2C%20minimal%20elegant%20background%2C%20editorial%20film%20photography%2C%20high%20detail&width=600&height=840&seq=kd-mothers-choice-poster&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20still%20of%20a%20humble%20street%20market%20stall%20at%20dusk%2C%20warm%20amber%20lights%20with%20cool%20navy%20evening%20shadows%2C%20everyday%20tender%20mood%2C%20minimal%20elegant%20composition%2C%20editorial%20film%20photography%2C%20high%20detail&width=1600&height=900&seq=kd-mothers-choice-bd&orientation=landscape',
    views: 934000,
    hot: false,
    featured: false,
  },
  {
    id: 'the-silent-father',
    title: '沉默的父亲',
    enTitle: 'The Silent Father',
    year: 2025,
    rating: 8.7,
    region: '韩国',
    genres: ['家庭伦理', '亲情成长'],
    tags: ['父子', '和解', '现实'],
    director: '郑允雅',
    cast: [
      { name: '李星民', role: '饰 姜德洙' },
      { name: '朴叙俊', role: '饰 姜宇镇' },
      { name: '韩艺璃', role: '饰 姜美娜' },
    ],
    status: '更新至第8集',
    episodes: 12,
    updatedAt: '2025-10-09',
    summary: '一个从不解释的父亲，和一个终于学会提问的儿子，在一趟长途货车里说完二十年的话。',
    synopsis:
      '姜德洙开了一辈子货车，把所有情绪都咽进肚子里。儿子姜宇镇在首尔做着不合父亲心意的工作，两人见面就吵。当德洙被查出身体出了问题，宇镇被迫替父亲跑完最后一条货运线路。漫长的公路上，父子第一次真正交谈。剧集用流动的风景与沉默的对话，讲述两代男人之间不善表达的深情。',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20Korean%20drama%20poster%20of%20a%20stoic%20older%20man%20looking%20out%20of%20a%20car%20window%20in%20the%20rain%2C%20cold%20navy%20tones%20with%20warm%20amber%20street%20lights%2C%20quiet%20loneliness%2C%20minimal%20elegant%20composition%2C%20editorial%20film%20photography%2C%20high%20detail&width=600&height=840&seq=kd-silent-father-poster&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20still%20of%20a%20long%20empty%20highway%20at%20dusk%20seen%20through%20a%20truck%20windshield%2C%20deep%20navy%20sky%20with%20warm%20amber%20sunset%20on%20the%20horizon%2C%20solitary%20reflective%20mood%2C%20elegant%20composition%2C%20editorial%20film%20photography%2C%20high%20detail&width=1600&height=900&seq=kd-silent-father-bd&orientation=landscape',
    views: 690000,
    hot: false,
    featured: false,
  },
  {
    id: 'winter-came-early',
    title: '冬天来得早',
    enTitle: 'Winter Came Early',
    year: 2024,
    rating: 8.2,
    region: '韩国',
    genres: ['婚姻情感', '悬疑伦理'],
    tags: ['失忆', '真相', '冷冽'],
    director: '闵秀珍',
    cast: [
      { name: '文素利', role: '饰 徐英爱' },
      { name: '曹承佑', role: '饰 白基泰' },
      { name: '金多美', role: '饰 白秀雅' },
    ],
    status: '全14集',
    episodes: 14,
    updatedAt: '2025-04-20',
    summary: '一场雪夜车祸后，妻子失去了十年记忆，醒来时发现身边的婚姻早已变了模样。',
    synopsis:
      '徐英爱在初雪那天出了车祸，醒来时记忆停留在十年前——那时她和白基泰还深爱着彼此。她被告知的现实却是：两人早已分居，女儿也已经长大。英爱努力拼凑这失去的十年，却发现每个被隐瞒的细节都指向同一个方向。剧集在冷冽的冬日氛围中，一步步揭开一段关系如何慢慢走散。',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20Korean%20drama%20poster%20of%20a%20woman%20in%20a%20wool%20coat%20standing%20in%20falling%20snow%2C%20cool%20navy%20winter%20palette%20with%20warm%20amber%20window%20light%20behind%2C%20sorrowful%20mood%2C%20minimal%20elegant%20background%2C%20editorial%20film%20photography%2C%20high%20detail&width=600&height=840&seq=kd-winter-early-poster&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20still%20of%20a%20quiet%20snowy%20residential%20street%20at%20blue%20hour%2C%20deep%20navy%20tones%20with%20warm%20amber%20house%20lights%2C%20cold%20reflective%20mood%2C%20minimal%20elegant%20composition%2C%20editorial%20film%20photography%2C%20high%20detail&width=1600&height=900&seq=kd-winter-early-bd&orientation=landscape',
    views: 601000,
    hot: false,
    featured: false,
  },
  {
    id: 'echo-of-lies',
    title: '谎言的回声',
    enTitle: 'Echo of Lies',
    year: 2025,
    rating: 8.9,
    region: '韩国',
    genres: ['悬疑伦理', '女性题材'],
    tags: ['心理', '复仇', '反转'],
    director: '崔东勋',
    cast: [
      { name: '金泰梨', role: '饰 河智安' },
      { name: '李钟硕', role: '饰 尹相赫' },
      { name: '千玗嬉', role: '饰 河智秀' },
    ],
    status: '更新至第13集',
    episodes: 16,
    updatedAt: '2025-10-07',
    summary: '为了掩盖十二年前的一个谎言，一对姐妹用尽一生去扮演别人，直到真相开始反噬。',
    synopsis:
      '河智安顶替姐姐的身份活了十二年，从一个小镇的优等生变成首尔光鲜的讲师。她以为只要足够努力就能把过去埋好，直到一个旧同学的意外出现。剧集用大量镜像与反射的镜头语言，讲述一个人在谎言中逐渐失重的过程，追问身份究竟能不能靠谎言重建。',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20Korean%20drama%20poster%20of%20a%20woman%20reflected%20in%20multiple%20mirrors%2C%20cool%20navy%20tones%20with%20warm%20amber%20rim%20light%2C%20suspenseful%20psychological%20mood%2C%20minimal%20elegant%20background%2C%20editorial%20film%20photography%2C%20high%20detail&width=600&height=840&seq=kd-echo-lies-poster&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20still%20of%20a%20dark%20hallway%20lined%20with%20tall%20mirrors%2C%20cool%20navy%20shadows%20with%20a%20single%20warm%20amber%20light%20source%2C%20tense%20psychological%20mood%2C%20elegant%20composition%2C%20editorial%20film%20photography%2C%20high%20detail&width=1600&height=900&seq=kd-echo-lies-bd&orientation=landscape',
    views: 1180000,
    hot: true,
    featured: false,
  },
  {
    id: 'two-homes',
    title: '两个家',
    enTitle: 'Two Homes',
    year: 2024,
    rating: 8.1,
    region: '韩国',
    genres: ['家庭伦理', '亲情成长'],
    tags: ['离婚', '孩子视角', '治愈'],
    director: '朴正勋',
    cast: [
      { name: '金裕贞', role: '饰 小恩' },
      { name: '柳俊烈', role: '饰 韩父' },
      { name: '郑裕美', role: '饰 韩母' },
    ],
    status: '全16集',
    episodes: 16,
    updatedAt: '2025-03-11',
    summary: '父母离婚后，十岁的小恩每周在两家之间来回，用孩子的眼睛丈量大人世界的裂缝。',
    synopsis:
      '十岁的小恩不明白为什么一个家会变成两个。她背着书包，每周五从妈妈家出发，周日晚上回到爸爸家，像一只在两棵树上筑巢的鸟。剧集以孩子的视角展开，用天真却锋利的观察，照见大人们的无措与努力。它不谈谁对谁错，只安静地讲述一个孩子如何学会爱两个家。',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20Korean%20drama%20poster%20of%20a%20child%20standing%20in%20a%20doorway%20between%20two%20rooms%2C%20cool%20navy%20shadows%20and%20warm%20amber%20lamp%20glow%2C%20torn%20family%20mood%2C%20minimal%20elegant%20composition%2C%20editorial%20film%20photography%2C%20high%20detail&width=600&height=840&seq=kd-two-homes-poster&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20still%20of%20a%20child%20with%20a%20backpack%20walking%20between%20two%20apartment%20buildings%20at%20dusk%2C%20cool%20navy%20tones%20with%20warm%20amber%20window%20lights%2C%20gentle%20melancholy%20mood%2C%20elegant%20composition%2C%20editorial%20film%20photography%2C%20high%20detail&width=1600&height=900&seq=kd-two-homes-bd&orientation=landscape',
    views: 548000,
    hot: false,
    featured: false,
  },
  {
    id: 'the-inheritance',
    title: '遗产',
    enTitle: 'The Inheritance',
    year: 2025,
    rating: 8.8,
    region: '韩国',
    genres: ['家庭伦理', '悬疑伦理'],
    tags: ['豪门', '争产', '暗涌'],
    director: '郑允雅',
    cast: [
      { name: '李锦熙', role: '饰 尹会长' },
      { name: '车胜元', role: '饰 尹宗宪' },
      { name: '徐睿知', role: '饰 尹夏景' },
    ],
    status: '更新至第11集',
    episodes: 18,
    updatedAt: '2025-10-06',
    summary: '老会长病重，一栋百年老宅的遗嘱里少了一个名字，让整个家族的体面开始崩裂。',
    synopsis:
      '尹氏家族三代经营着一家低调却殷实的贸易公司，表面和睦，暗地较劲。老会长一纸遗嘱没有提及从小被送养的小女儿，这个被抹去的名字成了引爆点。剧集将家族伦理与悬疑线索编织在一起，在精致的宅邸与正式的餐桌上，展开一场关于血缘、金钱与尊严的较量。',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20Korean%20drama%20poster%20of%20an%20old%20mansion%20interior%20with%20a%20family%20portrait%20on%20the%20wall%2C%20dark%20navy%20shadows%20and%20warm%20amber%20candle%20light%2C%20tense%20mood%2C%20minimal%20elegant%20background%2C%20editorial%20film%20photography%2C%20high%20detail&width=600&height=840&seq=kd-inheritance-poster&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20still%20of%20a%20formal%20dining%20room%20in%20an%20old%20mansion%2C%20dark%20navy%20tones%20with%20warm%20amber%20chandelier%20light%2C%20solemn%20tense%20mood%2C%20elegant%20composition%2C%20editorial%20film%20photography%2C%20high%20detail&width=1600&height=900&seq=kd-inheritance-bd&orientation=landscape',
    views: 1056000,
    hot: true,
    featured: false,
  },
  {
    id: 'love-after-loss',
    title: '失去之后的爱',
    enTitle: 'Love After Loss',
    year: 2025,
    rating: 8.4,
    region: '韩国',
    genres: ['婚姻情感', '亲情成长'],
    tags: ['丧偶', '疗愈', '温柔'],
    director: '闵秀珍',
    cast: [
      { name: '韩孝周', role: '饰 徐允儿' },
      { name: '朴海秀', role: '饰 李振宇' },
      { name: '金香起', role: '饰 小春天' },
    ],
    status: '更新至第9集',
    episodes: 16,
    updatedAt: '2025-10-04',
    summary: '丧偶的插画师和失去妻子的花店老板，在同一个公园长椅上，慢慢学会重新开始。',
    synopsis:
      '徐允儿失去了丈夫，独自带着女儿小春天生活；李振宇失去了妻子，守着一间快要倒闭的花店。两人因为每天清晨在同一张长椅上发呆而认识。故事没有轰轰烈烈的救赎，只有一次次沉默的陪伴、一顿顿分着吃的便当。剧集温柔地告诉观众：爱不会抹掉失去，但可以让人重新有勇气往前走。',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20Korean%20drama%20poster%20of%20a%20widow%20and%20a%20man%20sitting%20apart%20on%20a%20park%20bench%2C%20muted%20navy%20tones%20with%20warm%20amber%20autumn%20light%2C%20quiet%20healing%20mood%2C%20minimal%20elegant%20background%2C%20editorial%20film%20photography%2C%20high%20detail&width=600&height=840&seq=kd-love-after-loss-poster&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20still%20of%20a%20quiet%20city%20park%20bench%20under%20trees%20at%20golden%20hour%2C%20cool%20navy%20shadows%20with%20warm%20amber%20sunlight%2C%20healing%20tender%20mood%2C%20minimal%20elegant%20composition%2C%20editorial%20film%20photography%2C%20high%20detail&width=1600&height=900&seq=kd-love-after-loss-bd&orientation=landscape',
    views: 712000,
    hot: false,
    featured: false,
  },
  {
    id: 'price-of-truth',
    title: '真相的代价',
    enTitle: 'The Price of Truth',
    year: 2024,
    rating: 8.6,
    region: '韩国',
    genres: ['悬疑伦理', '家庭伦理'],
    tags: ['记者', '真相', '抉择'],
    director: '朴正勋',
    cast: [
      { name: '曹政奭', role: '饰 尹志浩' },
      { name: '李宝英', role: '饰 崔秀珍' },
      { name: '金武烈', role: '饰 张社长' },
    ],
    status: '全16集',
    episodes: 16,
    updatedAt: '2025-02-14',
    summary: '一名调查记者发现轰动新闻的关键人物，竟是自己岳父，真相与家庭之间他必须选一个。',
    synopsis:
      '尹志浩追踪了半年的一个企业丑闻，线索最终指向岳父名下的空壳公司。他越接近真相，家庭就越接近崩塌：妻子崔秀珍夹在父亲与丈夫之间，孩子也开始感受到沉默的紧张。剧集探讨新闻理想与私人情感的冲突，让观众思考当真相需要以家庭为代价时，一个人究竟该如何选择。',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20Korean%20drama%20poster%20of%20a%20journalist%20looking%20at%20scattered%20photographs%20on%20a%20desk%2C%20cool%20navy%20shadows%20with%20warm%20amber%20desk%20lamp%2C%20investigative%20tension%2C%20minimal%20elegant%20background%2C%20editorial%20film%20photography%2C%20high%20detail&width=600&height=840&seq=kd-price-truth-poster&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20still%20of%20a%20late%20night%20newsroom%20lit%20by%20monitors%2C%20cool%20navy%20tones%20with%20warm%20amber%20desk%20lamps%2C%20tense%20focused%20mood%2C%20minimal%20elegant%20composition%2C%20editorial%20film%20photography%2C%20high%20detail&width=1600&height=900&seq=kd-price-truth-bd&orientation=landscape',
    views: 689000,
    hot: false,
    featured: false,
  },
  {
    id: 'homecoming-tide',
    title: '归潮',
    enTitle: 'Homecoming Tide',
    year: 2025,
    rating: 8.5,
    region: '韩国',
    genres: ['亲情成长', '家庭伦理'],
    tags: ['返乡', '原生家庭', '治愈'],
    director: '崔东勋',
    cast: [
      { name: '孔刘', role: '饰 郑海率' },
      { name: '金敏喜', role: '饰 郑海仁' },
      { name: '尹汝贞', role: '饰 郑奶奶' },
    ],
    status: '更新至第7集',
    episodes: 14,
    updatedAt: '2025-10-03',
    summary: '离开渔村十二年的儿子因为奶奶的葬礼归来，才发现自己从未真正离开过这片海。',
    synopsis:
      '郑海率当年为了逃离小渔村，和家里闹得不可开交，一走就是十二年。奶奶的葬礼把他拉回原点，面对始终不肯原谅他的父亲和守着老屋的妹妹。剧集用潮汐的意象贯穿始终——海水一次次退去又涌来，像极了人与故乡之间剪不断的关系。这是一个关于原谅别人也原谅自己的故事。',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20Korean%20drama%20poster%20of%20a%20grown%20son%20returning%20to%20a%20seaside%20village%20house%2C%20deep%20navy%20sea%20tones%20with%20warm%20amber%20home%20lights%2C%20reunion%20mood%2C%20minimal%20elegant%20background%2C%20editorial%20film%20photography%2C%20high%20detail&width=600&height=840&seq=kd-homecoming-tide-poster&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20still%20of%20a%20fishing%20village%20at%20low%20tide%20during%20twilight%2C%20deep%20navy%20sea%20and%20warm%20amber%20house%20lights%2C%20nostalgic%20quiet%20mood%2C%20minimal%20elegant%20composition%2C%20editorial%20film%20photography%2C%20high%20detail&width=1600&height=900&seq=kd-homecoming-tide-bd&orientation=landscape',
    views: 654000,
    hot: false,
    featured: false,
  },
  {
    id: 'sunset-family',
    title: '黄昏之家',
    enTitle: 'Sunset Family',
    year: 2024,
    rating: 8.3,
    region: '韩国',
    genres: ['家庭伦理', '亲情成长'],
    tags: ['养老', '陪伴', '温情'],
    director: '闵秀珍',
    cast: [
      { name: '尹汝贞', role: '饰 吴末顺' },
      { name: '李顺载', role: '饰 崔德培' },
      { name: '罗文姬', role: '饰 朴英子' },
    ],
    status: '全20集',
    episodes: 20,
    updatedAt: '2025-01-30',
    summary: '一家郊外养老院里，几位老人用各自的黄昏时光，教会年轻护理员什么叫好好活着。',
    synopsis:
      '郊外的一家小养老院，住着脾气倔强的吴末顺、爱讲旧事的崔德培和总在织毛衣的朴英子。年轻的护理员小周初来时满心不耐烦，却在日复一日的相处中，被这些老人各自的故事打动。剧集以温暖喜剧的笔触，讲述衰老、孤独与陪伴，提醒我们黄昏的光也值得被认真对待。',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20Korean%20drama%20poster%20of%20an%20aging%20couple%20sitting%20on%20a%20porch%20at%20sunset%2C%20navy%20dusk%20tones%20and%20warm%20amber%20sky%2C%20gentle%20nostalgic%20mood%2C%20minimal%20elegant%20background%2C%20editorial%20film%20photography%2C%20high%20detail&width=600&height=840&seq=kd-sunset-family-poster&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20still%20of%20a%20quiet%20nursing%20home%20garden%20at%20golden%20sunset%2C%20deep%20navy%20shadows%20with%20warm%20amber%20light%2C%20warm%20peaceful%20mood%2C%20minimal%20elegant%20composition%2C%20editorial%20film%20photography%2C%20high%20detail&width=1600&height=900&seq=kd-sunset-family-bd&orientation=landscape',
    views: 512000,
    hot: false,
    featured: false,
  },
];

export const specials = [
  {
    id: 'classic-family-ethics',
    title: '经典家庭伦理剧精选',
    subtitle: '那些让人记住十几年的家庭故事',
    intro:
      '精选近十年最具代表性的韩国家庭伦理剧，从代际关系到亲情和解，每一部都值得反复细看。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20collage%20style%20still%20of%20a%20warm%20family%20dinner%20table%20scene%2C%20deep%20navy%20shadows%20with%20warm%20amber%20light%2C%20nostalgic%20emotional%20mood%2C%20minimal%20elegant%20composition%2C%20film%20photography%2C%20high%20detail&width=1200&height=675&seq=kd-special-classic&orientation=landscape',
    dramaIds: ['weight-of-home', 'the-other-mother', 'mothers-choice', 'sunset-family'],
  },
  {
    id: 'marriage-truths',
    title: '婚姻的真相：情感解析专题',
    subtitle: '当爱情走进日常之后',
    intro:
      '聚焦婚姻题材，从沉默、疏离到重新选择，解析韩国伦理剧如何书写成年人的情感困境。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20style%20still%20of%20an%20empty%20marital%20bedroom%20with%20rumpled%20sheets%2C%20cool%20navy%20tones%20with%20warm%20amber%20bedside%20lamp%2C%20quiet%20emotional%20tension%2C%20minimal%20elegant%20composition%2C%20film%20photography%2C%20high%20detail&width=1200&height=675&seq=kd-special-marriage&orientation=landscape',
    dramaIds: ['silent-marriage', 'glass-heart', 'winter-came-early', 'price-of-truth'],
  },
  {
    id: 'healing-corner',
    title: '治愈角落：温柔向前的人生',
    subtitle: '在失去之后，学会重新开始',
    intro:
      '一组以疗愈为核心的伦理剧，讲述普通人如何在失落后重新站稳，慢慢把日子过回自己的节奏。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20style%20still%20of%20a%20sunlit%20window%20seat%20with%20a%20cup%20of%20tea%20and%20open%20book%2C%20warm%20amber%20light%20with%20cool%20navy%20shadows%2C%20calm%20healing%20mood%2C%20minimal%20elegant%20composition%2C%20film%20photography%2C%20high%20detail&width=1200&height=675&seq=kd-special-healing&orientation=landscape',
    dramaIds: ['borrowed-time', 'her-second-spring', 'love-after-loss', 'homecoming-tide'],
  },
  {
    id: 'women-stories',
    title: '她视角：女性题材专题',
    subtitle: '关于选择、独立与成长',
    intro:
      '从家庭主妇到职场女性，从母亲到女儿，看韩国伦理剧如何用女性视角讲述更复杂的现实。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20style%20still%20of%20a%20woman%20looking%20out%20of%20a%20large%20window%20at%20city%20lights%2C%20cool%20navy%20tones%20with%20warm%20amber%20reflections%2C%20reflective%20empowered%20mood%2C%20minimal%20elegant%20composition%2C%20film%20photography%2C%20high%20detail&width=1200&height=675&seq=kd-special-women&orientation=landscape',
    dramaIds: ['glass-heart', 'her-second-spring', 'echo-of-lies', 'mothers-choice'],
  },
  {
    id: 'suspense-ethics',
    title: '暗涌：悬疑伦理合辑',
    subtitle: '秘密藏在体面的日常之下',
    intro:
      '当伦理剧遇上悬疑，秘密、谎言与真相交织。这组合辑收录情节最强、反转最多的作品。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20style%20still%20of%20a%20dim%20hallway%20with%20a%20partially%20open%20door%20and%20light%20spilling%20through%2C%20deep%20navy%20shadows%20with%20warm%20amber%20glow%2C%20mysterious%20tense%20mood%2C%20minimal%20elegant%20composition%2C%20film%20photography%2C%20high%20detail&width=1200&height=675&seq=kd-special-suspense&orientation=landscape',
    dramaIds: ['secrets-in-autumn', 'echo-of-lies', 'winter-came-early', 'the-inheritance'],
  },
  {
    id: 'father-son',
    title: '父与子：亲情主题特辑',
    subtitle: '沉默背后说不出口的爱',
    intro:
      '不善表达的父亲与勇敢提问的孩子。这组作品共同书写东亚家庭里最隐忍的一种深情。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20style%20still%20of%20a%20father%20and%20son%20sitting%20in%20silence%20at%20a%20riverside%20at%20dusk%2C%20deep%20navy%20tones%20with%20warm%20amber%20sunset%20light%2C%20restrained%20tender%20mood%2C%20minimal%20elegant%20composition%2C%20film%20photography%2C%20high%20detail&width=1200&height=675&seq=kd-special-father&orientation=landscape',
    dramaIds: ['the-silent-father', 'borrowed-time', 'weight-of-home', 'two-homes'],
  },
];